import type Luminary from '@lumen5/luminary';

import type { LintFinding } from '../videoLinter';

import type { GetRootState } from 'js/src/luminary/luminary-redux-connect-types';
import { calculateAllTextContrastsForVideo } from 'js/src/luminary/text-contrast-utils';
import { meetsWCAG_AA } from 'js/src/utils/contrast-utils';

/**
 * Error: text overlapping media has a contrast ratio below the WCAG AA
 * threshold (4.5:1 for normal text), making it hard to read against its
 * background.
 */
export async function checkTextContrast(
    luminary: Luminary,
    _getState: GetRootState,
): Promise<LintFinding[]> {
    const findings: LintFinding[] = [];
    const canvas = document.createElement('canvas');

    const resultsBySceneId = await calculateAllTextContrastsForVideo(luminary, canvas);

    luminary.scenes.forEach((scene) => {
        const results = resultsBySceneId.get(scene.id);
        if (!results) {
            return;
        }
        results.forEach((result) => {
            if (meetsWCAG_AA(result.contrastRatio)) {
                return;
            }
            const ratio = result.contrastRatio.toFixed(1);
            const text = result.textContent.trim();
            findings.push({
                check: 'text_contrast',
                severity: 'error',
                sceneId: scene.id,
                message: `Low text contrast (${ratio}:1, below the WCAG AA minimum of 4.5:1)${
                    text ? ` for "${text}"` : ''
                }. Dim the media behind it, change the text color, or reposition the text.`,
            });
        });
    });

    return findings;
}
